import { useState } from 'react';
import { Bell, ChevronDown } from 'lucide-react';
import { WhatsAppToggle } from './WhatsAppToggle';
import { TelegramToggle } from './TelegramToggle';

const STORAGE_KEY = 'admin-notifications-panel-open';

// Collapsible wrapper for the WhatsApp + Telegram admin toggles (collapsed by default to save space)
export const NotificationsPanel = () => {
    const [open, setOpen] = useState(() => localStorage.getItem(STORAGE_KEY) === '1');
    const toggle = () => {
        const next = !open;
        setOpen(next);
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    };

    return (
        <div className="border-b border-slate-200 bg-sky-50" data-testid="notifications-panel">
            <button
                type="button"
                onClick={toggle}
                aria-expanded={open}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-sky-100/60 transition-colors"
                data-testid="notifications-panel-toggle"
            >
                <Bell className="w-4 h-4 text-sky-600 shrink-0" />
                <span className="text-sm font-medium text-slate-700 flex-1">Notificaciones admin</span>
                <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && (
                <div className="pb-1" data-testid="notifications-panel-content">
                    <WhatsAppToggle />
                    <TelegramToggle />
                </div>
            )}
        </div>
    );
};

export default NotificationsPanel;
